export const BRAND = {
  name: "ELA Rituals",
  community: "Rituals With You",
  descriptor: "A community by ELA Rituals",
  tagline: "Your Rituals. Our Journey.",
  participation: "Discover • Experience • Share",
  system: "The 3-Way System",
  philosophy: "Formulation with Intention",
  dashboard: "My Rituals",
  joinCta: "Join the Community",
  exploreCta: "Explore Our Rituals",
  heroCopy:
    "A space to discover skincare, share your experiences, and learn together—one ritual at a time.",
};

export const NAV = [
  { label: "Our Rituals", to: "/products" },
  { label: "The 3-Way System", to: "/three-way-system" },
  { label: "Rituals With You", to: "/community" },
  { label: "Journal", to: "/journal" },
];
